export const getParamsFromArray = (
  arr: {
    key: string;
    value: string | number | boolean;
  }[],
  addSpecifier: boolean,
) =>
  arr.reduce(
    (acc, { key, value }, i) => {
      if (!value) return acc;
      if (value && i < arr.length - 1) {
        return `${acc}${key}=${value}&`;
      }
      return `${acc}${key}=${value}`;
    },
    addSpecifier ? '?' : '',
  );

export const getURLWithParamsFromArray = (
  url: string,
  params: {
    key: string;
    value: string | number | boolean;
  }[],
  addSpecifier: boolean,
) => `${url}${getParamsFromArray(params, addSpecifier)}`;
